<template>
    <div class="product-quick-win">
        <!-- 快速浏览弹窗 -->
        <div class="queryViewWinPage m_flex m_aic m_jcc" v-if="vuex_quick_win">
            <div class="winBox">
                <div class="closeBtn m_flex m_aic m_jcc m_kuoda" @click="queryViewWinSwitch('关')">
                    <i class="el-icon-close closeIcon"></i>
                </div>
                <div class="flexBox m_ais m_jcsb">
                    <div class="lImgBox">
                        <img :src="quickWinImg" class="img" alt="" />
                    </div>
                    <div class="rBox" v-if="detail.inventorys">
                        <div class="title">{{ detail.subtitle }}</div>
                        <div class="title2" @click="goProductDetail">{{ detail.zSn }}</div>
                        <div class="title3">{{ detail.title }}</div>
                        <!-- <div class="title4">2.7 μm particle size, L × I.D. 10 cm × 4.6 mm</div> -->
                        <!-- <div class="title5" v-if="detail.skuLists">{{ detail.skuLists[0]['key'] }}</div> -->
                        <div class="winGreyLine"></div>
                        <div class="labelFlexBox m_ais m_jcs m_wrap">
                            <div
                                class="item"
                                @click="selectSku(index)"
                                :class="{ active: index == skuIndex }"
                                v-for="(item, index) in detail.inventorys"
                                :key="index"
                            >
                                {{ item.keyVals || item.spec || item.sn || '—' }}
                            </div>
                        </div>
                        <div class="price">¥{{ detail.inventorys[skuIndex]['priceSale'] }}</div>
                        <div class="yesFlexBox m_flex m_aic m_jcs">
                            <i class="el-icon-circle-check yesIcon" v-if="detail.inventorys[skuIndex]['kucun'] > 0"></i>
                            <div class="yesText">{{ detail.inventorys[skuIndex]['kucun'] > 0 ? '有货' : '无货' }}</div>
                            <!-- <el-tooltip class="item" effect="dark" content="Top Right 提示文字" placement="top-start">
                                <div class="carBox">
                                    <img src="@/assets/images/car.png" class="carIcon" alt="" />
                                </div>
                            </el-tooltip> -->
                        </div>
                        <div class="addFlexBox m_aic m_jcs">
                            <div class="myInputNumber">
                                <el-input-number v-model="num" :min="1" :max="detail.inventorys[skuIndex]['kucun']"></el-input-number>
                            </div>
                            <div class="addCarBtn m_fcc btn-ripple" @click="addCar">加入购物车</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="bottomBtnFlexBox m_flex m_aic m_jce">
                    <div class="selectBox m_flex m_aic m_jcc">
                        <div class="m_checkBox active">
                            <i class="el-icon-check m_checkIcon"></i>
                        </div>
                        <div class="text">抄送给我</div>
                    </div>
                    <div class="subBtn m_flex m_aic m_jcc btn-ripple">发送电子邮件</div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            num: 1,

            detail: {},

            skuIndex: 0,
        }
    },
    computed: {
        ...mapState({
            vuex_quick_win: (state) => state.vuex_quick_win,
            vuex_quick_id: (state) => state.vuex_quick_id,
        }),
        // 快速浏览弹窗图片：当前选中 SKU 的图 > 产品 thumb > 首张图，相对路径补全
        quickWinImg() {
            if (!this.detail || !this.detail.inventorys || !this.detail.inventorys.length) return this.vuex_default_img
            const idx = Math.min(this.skuIndex, this.detail.inventorys.length - 1)
            const sku = this.detail.inventorys[idx]
            let url = (sku && (sku.image || sku.thumb)) || this.detail.thumb || (this.detail.images && this.detail.images[0])
            url = url && String(url).trim() ? url : ''
            if (!url) return this.vuex_default_img
            if (url.startsWith('/') && !url.startsWith('//')) {
                const origin = typeof window !== 'undefined' && window.location && window.location.origin ? window.location.origin : ''
                url = origin + url
            }
            return url
        },
    },
    watch: {
        vuex_quick_win: {
            immediate: true,
            deep: true,
            handler(newV) {
                if (newV == true) {
                    this.getDetail()
                }
            },
        },
    },
    created() {},
    mounted() {},
    methods: {
        goProductDetail() {
            this.$router.push({
                path: '/product-detail',
                query: {
                    id: this.detail.inventoryId,
                },
            })
        },
        // 加入购物车
        async addCar() {
            if (!this.vuex_isLogin) {
                alertErr('请先登录')
                return
            }
            if (this.detail.kucun == 0) {
                alertErr('库存不足')
                return
            }
            this.$load.open()
            await this.mix_addCar(this.vuex_quick_id, this.num)
            this.$load.close(300)
            alertSucc('添加成功')
        },
        selectSku(index) {
            this.skuIndex = index
        },
        async getDetail() {
            this.$load.open()
            let res = await this.api_product_detail({
                inventoryId: this.vuex_quick_id,
                ifShowSku: 1,
            })
            this.$load.close()
            if (res.code == 200) {
                this.detail = res.data
                this.skuIndex = 0
            } else {
                alertErr(res.msg)
            }
        },
        queryViewWinSwitch(text) {
            if (text == '关') {
                this.$store.commit('set_vuex_data', {
                    k: 'vuex_quick_win',
                    v: false,
                })
                return
            }
        },
        api_product_detail(obj) {
            return new Promise(async (resolve, reject) => {
                this.$api('product_detail', obj).then((res) => {
                    resolve(res)
                })
            })
        },
    },
}
</script>

<style lang="less" scoped>
.product-quick-win {
    .queryViewWinPage {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 99;

        .winBox {
            width: 840px;
            max-height: 70vh;
            background: #ffffff;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #707070;
            padding: 22px 26px;
            position: relative;
            overflow-y: auto;

            .closeBtn {
                width: 14px;
                height: 14px;
                cursor: pointer;
                position: absolute;
                top: 22px;
                right: 26px;

                .closeIcon {
                    font-size: 24px;
                    color: #000000;
                }
            }

            .flexBox {
                width: 100%;

                .lImgBox {
                    width: 90px;
                    height: 90px;
                    background: #ffffff;
                    border-radius: 3px 3px 3px 3px;
                    border: 1px solid #c9c9c9;
                    margin-right: 24px;

                    .img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }

                .rBox {
                    width: calc(100% - 90px - 24px);

                    .addFlexBox {
                        margin-top: 30px;

                        .addCarBtn {
                            margin-left: 18px;
                            font-weight: bold;
                            font-size: 16px;
                            color: #ffffff;
                            line-height: 22px;
                            text-align: left;
                            cursor: pointer;
                            width: 137px;
                            height: 49px;
                            background: #d61818;
                            border-radius: 5px 5px 5px 5px;
                        }

                        .myInputNumber {
                            :deep .el-input-number {
                                width: 130px;
                            }

                            :deep .el-input-number__decrease:hover {
                                color: #d61818;
                            }

                            :deep .el-input-number__increase:hover {
                                color: #d61818;
                            }

                            :deep .el-input-number__decrease:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled),
                            :deep .el-input-number__increase:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled) {
                                border-color: #d61818;
                            }

                            :deep .el-input.is-active .el-input__inner,
                            :deep .el-input__inner:focus {
                                border-color: #d61818;
                            }
                        }
                    }

                    .title {
                        font-weight: 400;
                        font-size: 12px;
                        color: #06B2AB;
                        cursor: pointer;
                        line-height: 24px;
                        text-align: left;
                    }

                    .title2 {
                        font-weight: bold;
                        font-size: 18px;
                        color: #d61818;
                        line-height: 24px;
                        text-align: left;
                        cursor: pointer;
                    }

                    .title3 {
                        font-weight: 900;
                        font-size: 18px;
                        color: #000000;
                        line-height: 25px;
                        text-align: left;
                        margin-bottom: 15px;
                    }

                    .title4 {
                        font-weight: 400;
                        font-size: 14px;
                        color: #000000;
                        line-height: 20px;
                        text-align: left;
                        margin-bottom: 10px;
                    }

                    .title5 {
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                        line-height: 20px;
                        text-align: left;
                        margin-top: 30px;
                        margin-bottom: 5px;
                    }

                    .winGreyLine {
                        width: 100%;
                        height: 1px;
                        background: lightgray;
                    }

                    .labelFlexBox {
                        width: 100%;

                        .item {
                            cursor: pointer;
                            width: fit-content;
                            padding: 5px 16px;
                            background: transparent;
                            border-radius: 16px 16px 16px 16px;
                            border: 1px solid lightgray;
                            margin-top: 10px;
                            margin-right: 15px;
                            font-weight: 400;
                            font-size: 12px;
                            color: #000;
                            line-height: 18px;
                            text-align: left;

                            &.active {
                                background: #ffdbdb;
                                border: 1px solid #d61818;
                                color: #d61818;
                            }
                        }
                    }

                    .price {
                        font-weight: bold;
                        font-size: 24px;
                        color: #000000;
                        line-height: 34px;
                        text-align: left;
                        margin-top: 20px;
                        margin-bottom: 12px;
                    }

                    .yesFlexBox {
                        margin-bottom: 5px;

                        .yesIcon {
                            font-size: 18px;
                            color: #32a365;
                            margin-right: 6px;
                        }

                        .yesText {
                            font-weight: 400;
                            font-size: 14px;
                            color: #000000;
                            line-height: 18px;
                            text-align: left;
                        }
                    }

                    .carBox {
                        width: 26px;
                        height: 16px;
                        margin-left: 5px;
                        cursor: pointer;

                        .carIcon {
                            width: 26px;
                            height: 16px;
                            display: block;
                        }
                    }
                }
            }

            .bottomBtnFlexBox {
                width: 100%;

                .selectBox {
                    margin-right: 24px;

                    .text {
                        margin-left: 7px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #000000;
                        line-height: 24px;
                        text-align: left;
                    }
                }

                .subBtn {
                    width: 148px;
                    height: 40px;
                    background: #d61818;
                    border-radius: 5px 5px 5px 5px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #ffffff;
                    line-height: 24px;
                    text-align: left;
                }
            }
        }
    }
}
</style>
